import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import adminNotificationSlice from "./slice/adminNotificationSlice";
import settingsReducer from "./slice/settingsSlice";
import dealerCommFilterSlice from "./slice/dealerCommFilterSlice";
import bonusReducer from "./slice/bonusSlice";
import newFloorApplication from "./slice/newFloorApplication";
import guarantorInfoSlice from "./slice/guarantorInfoSlice";


const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  adminNotificationFilter: adminNotificationSlice,
  settings: settingsReducer,
  dealerCommFilter: dealerCommFilterSlice,
  bonus: bonusReducer,
  newFloorApplication: newFloorApplication,
  guarantorInfo: guarantorInfoSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = configureStore({
//   reducer: rootReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });

// export default store;

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
